import { Flex, Tooltip, Typography, theme } from 'antd';
import { formatCurrency } from '../../../utils/currencyUtils';
import ProgressBar from '../../ProgressBar';
import type { TopAdvertiser } from '@/types';
import { formatPercentage } from '@/utils';

const Advertiser = ({
  data,
  format = 'compact',
}: {
  data: TopAdvertiser;
  format?: 'compact' | 'full';
}) => {
  const { token } = theme.useToken();
  const hasCategories = data.categories && data.categories.length > 0;

  const tooltipContent = (
    <Flex component="span" gap={2} vertical>
      {data.categories?.map((category) => (
        <Flex component="span" key={category.id} vertical>
          <strong>{category.name}</strong>
          {category.subcategories?.map((subCategory) => (
            <span key={subCategory.id}>{subCategory.name}</span>
          ))}
        </Flex>
      ))}
    </Flex>
  );

  const captionText = data.categories
    ?.map((category) => {
      const getCategoryNameWithoutId = (categoryName: string) => categoryName.split(' - ')[1];
      let text = getCategoryNameWithoutId(category.name);
      if (category.subcategories?.length) {
        text += ` (${category.subcategories
          ?.map((subCat) => getCategoryNameWithoutId(subCat.name))
          .join(', ')})`;
      }
      return text;
    })
    .join(', ');

  return (
    <>
      <Flex justify="space-between" style={{ fontSize: token.fontSize, color: token.colorText }}>
        {hasCategories ? (
          <Tooltip
            title={tooltipContent}
            placement="topLeft"
            styles={{ root: { fontSize: token.fontSizeSM } }}
          >
            <Typography.Text strong>{data.brand}</Typography.Text>
          </Tooltip>
        ) : (
          <Typography.Text strong>{data.brand}</Typography.Text>
        )}
        <Typography.Text>{formatCurrency(data.total.amount, data.total.currency)}</Typography.Text>
      </Flex>
      <ProgressBar height="8px" percentage={`${data.percentage}%`} />

      {format === 'full' && (
        <Typography.Text
          ellipsis
          style={{ color: token.colorTextSecondary, fontSize: token.fontSizeSM }}
        >
          {formatPercentage(data.percentage)}%{captionText ? ' • ' + captionText : ''}
        </Typography.Text>
      )}
    </>
  );
};

export default Advertiser;
